document.addEventListener('click', (event) => {
  const trigger = event.target.closest('[data-menu-toggle]');
  if (trigger) document.body.classList.toggle('menu-open');
});

function formatMoney(cents, currencyCode) {
  try {
    return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
      style: 'currency',
      currency: currencyCode || 'GBP'
    }).format(Number(cents) / 100);
  } catch (error) {
    return `£${(Number(cents) / 100).toFixed(2)}`;
  }
}

function initProduct(root) {
  const slides = [...root.querySelectorAll('[data-media-id].product-gallery-slide')];
  const thumbs = [...root.querySelectorAll('[data-gallery-thumb]')];
  const currentCounter = root.querySelector('[data-gallery-current]');
  const select = root.querySelector('[data-variant-select]');
  const priceBox = root.querySelector('[data-product-price]');
  const stockBox = root.querySelector('[data-product-stock]');
  const addButton = root.querySelector('[data-add-to-cart]');
  const quantityInput = root.querySelector('[data-quantity-input]');
  const currency = window.Shopify?.currency?.active || 'GBP';
  let activeIndex = Math.max(0, slides.findIndex((slide) => slide.classList.contains('is-active')));

  const showMedia = (indexOrId) => {
    if (!slides.length) return;
    let nextIndex = typeof indexOrId === 'number'
      ? indexOrId
      : slides.findIndex((slide) => String(slide.dataset.mediaId) === String(indexOrId));
    if (nextIndex < 0) nextIndex = 0;
    activeIndex = (nextIndex + slides.length) % slides.length;
    slides.forEach((slide, index) => slide.classList.toggle('is-active', index === activeIndex));
    thumbs.forEach((thumb, index) => thumb.classList.toggle('is-active', index === activeIndex));
    if (currentCounter) currentCounter.textContent = String(activeIndex + 1);
    thumbs[activeIndex]?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
  };

  thumbs.forEach((thumb) => thumb.addEventListener('click', () => showMedia(Number(thumb.dataset.mediaIndex))));
  root.querySelector('[data-gallery-prev]')?.addEventListener('click', () => showMedia(activeIndex - 1));
  root.querySelector('[data-gallery-next]')?.addEventListener('click', () => showMedia(activeIndex + 1));

  let touchStartX = 0;
  const mediaFrame = root.querySelector('.product-main-media--gallery');
  mediaFrame?.addEventListener('touchstart', (event) => { touchStartX = event.changedTouches[0].clientX; }, { passive: true });
  mediaFrame?.addEventListener('touchend', (event) => {
    const delta = event.changedTouches[0].clientX - touchStartX;
    if (Math.abs(delta) > 45) showMedia(activeIndex + (delta < 0 ? 1 : -1));
  }, { passive: true });

  const updateVariant = () => {
    if (!select || select.tagName !== 'SELECT') return;
    const option = select.options[select.selectedIndex];
    const available = option.dataset.available === 'true';
    const price = Number(option.dataset.price || 0);
    const comparePrice = Number(option.dataset.comparePrice || 0);
    const mediaId = option.dataset.mediaId;

    if (priceBox) {
      let markup = `<strong>${formatMoney(price, currency)}</strong>`;
      if (comparePrice > price) {
        const saving = Math.round(((comparePrice - price) / comparePrice) * 100);
        markup += ` <span class="compare">${formatMoney(comparePrice, currency)}</span> <span class="sale-badge sale-badge--inline">SAVE ${saving}%</span>`;
      }
      priceBox.innerHTML = markup;
    }

    if (stockBox) {
      stockBox.textContent = available ? '● In stock' : '● Sold out';
      stockBox.classList.toggle('is-sold-out', !available);
    }
    if (addButton) {
      addButton.disabled = !available;
      addButton.textContent = available ? 'ADD TO CART' : 'SOLD OUT';
    }
    if (mediaId) showMedia(mediaId);

    const url = new URL(window.location.href);
    url.searchParams.set('variant', option.value);
    window.history.replaceState({}, '', url);
  };

  select?.addEventListener('change', updateVariant);
  root.querySelector('[data-quantity-minus]')?.addEventListener('click', () => {
    if (quantityInput) quantityInput.value = Math.max(1, Number(quantityInput.value || 1) - 1);
  });
  root.querySelector('[data-quantity-plus]')?.addEventListener('click', () => {
    if (quantityInput) quantityInput.value = Number(quantityInput.value || 1) + 1;
  });
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-product-root]').forEach(initProduct);
});
